/**
 * RulesPanelButton — toolbar entry point that opens the Rules & automation panel
 * (SE-5506).
 * @module features/player-kanban/components/organisms/RulesPanelButton
 */

export { default } from "./RulesPanelButtonContainer";
export type { RulesPanelButtonContainerProps } from "./RulesPanelButtonContainer";
